import React, { useEffect, useState } from "react";
import { Accordion, Segment, Icon } from "semantic-ui-react";

// Components
import FormMenu from "./FormMenu";

import pdfFileObject from "../../result_v1.json";
const FormAccordion = ({ position }) => {
  const [activeIndex, setActiveState] = useState(0);
  const [state, setState] = useState({
    firstValue: 0,
    lastValue: 7,
  });
  useEffect(() => {
    position === "left"
      ? setState({
          firstValue: 0,
          lastValue: 2,
        })
      : position === "right"
      ? setState({
          firstValue: 3,
          lastValue: 5,
        })
      : setState({
          firstValue: 6,
          lastValue: 8,
        });

    setActiveState(state.firstValue);
  }, [position, state.firstValue]);

  const pdfEnum = Object.keys(pdfFileObject);
  return (
    <Accordion styled>
      {Object.keys(pdfFileObject).map(
        (item) =>
          pdfEnum.indexOf(item) >= state.firstValue &&
          pdfEnum.indexOf(item) <= state.lastValue && (
            <Segment key={pdfEnum.indexOf(item)} color="grey">
              <Accordion.Title
                active={activeIndex === pdfEnum.indexOf(item)}
                index={pdfEnum.indexOf(item)}
                onClick={() =>
                  setActiveState(
                    activeIndex === pdfEnum.indexOf(item)
                      ? -1
                      : pdfEnum.indexOf(item)
                  )
                }
              >
                <Icon name="dropdown" />
                File Name: {pdfEnum[pdfEnum.indexOf(item)]}
              </Accordion.Title>
              <Accordion.Content active={activeIndex === pdfEnum.indexOf(item)}>
                <FormMenu enums={pdfEnum[pdfEnum.indexOf(item)]} />
              </Accordion.Content>
            </Segment>
          )
      )}
    </Accordion>
  );
};

export default FormAccordion;
